import React, { useState } from 'react';
import { motion } from 'framer-motion';
import img1 from '../assets/gallery/img1.jpeg';
import img2 from '../assets/gallery/img2.jpeg';
import img3 from '../assets/gallery/img3.jpeg';
import img4 from '../assets/gallery/img4.jpeg';
import img5 from '../assets/gallery/img5.jpeg';
import img6 from '../assets/gallery/img6.jpeg';
import img7 from '../assets/gallery/img7.jpeg';
import img8 from '../assets/gallery/img8.jpeg';
import img9 from '../assets/gallery/img9.jpeg';
import img10 from '../assets/gallery/img10.jpeg';
import img11 from '../assets/gallery/img11.jpeg';
import img12 from '../assets/gallery/img12.jpeg';
import img13 from '../assets/gallery/img13.jpeg';
import img14 from '../assets/gallery/img14.jpeg';
import img15 from '../assets/gallery/img15.jpeg';
import img19 from '../assets/gallery/img19.jpeg';
import img20 from '../assets/gallery/img20.jpeg';

import bg1 from '../assets/bg1.jpg';

const images = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img19, img20
];

const Gallery = () => {
    const bgimages = [bg1];
    const bgNum = Math.floor(Math.random() * bgimages.length);
    const bgImage = bgimages[bgNum];

    const [selectedImage, setSelectedImage] = useState(null);

    const openImage = (index) => {
        setSelectedImage(index);
    };

    const closeImage = () => {
        setSelectedImage(null);
    };

    return (
        <div className="flex flex-col min-h-screen">
            <motion.div
                className="relative h-96 bg-cover bg-center"
                style={{ backgroundImage: `url(${bgImage})` }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center flex-col">
                    <h1 className="text-[#EFF8E2] text-4xl font-bold mb-4 px-6">Work we've done in the past</h1>
                    <motion.div
                        whileHover={{
                            scale: 1.1,
                            translateZ: 50,
                            perspective: 1000,
                            boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
                            transition: { duration: 0.2 }
                        }}
                        className="inline-block mb-4"
                    >
                        <a href="tel:+15099416012" className="bg-[#1446A0] text-[#EFF8E2] px-4 py-2 rounded font-bold">
                            <span>📞</span><span>Call us at (509) 941 6012 to Book</span>
                        </a>
                    </motion.div>
                </div>
            </motion.div>
            <div className="container mx-auto px-4 py-8 flex-1">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {images.map((image, index) => (
                        <motion.div
                            key={index}
                            className="border"
                            whileHover={{
                                scale: 1.1,
                                translateZ: 50,
                                perspective: 1000,
                                boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
                                transition: { duration: 0.2 }
                            }}
                            whileTap={{ scale: 0.95 }}
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            onClick={() => openImage(index)}
                        >
                            <img src={image} alt={`Gallery ${index}`} className="w-full h-96 object-cover" />
                        </motion.div>
                    ))}
                </div>
            </div>

            {selectedImage !== null && (
                <motion.div
                    className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.3 }}
                    onClick={closeImage}
                >
                    <motion.img
                        src={images[selectedImage]}
                        alt={`Gallery ${selectedImage}`}
                        className="max-w-full max-h-full px-4 sm:px-3"
                        initial={{ y: "-100vh" }}
                        animate={{ y: 0 }}
                        transition={{ type: "spring", stiffness: 100, damping: 20 }}
                    />
                </motion.div>
            )}
        </div>
    );
};

export default Gallery;
